import React from "react";

const BoxShadow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="812"
      height="166"
      viewBox="0 0 812 166"
    >
      <ellipse
        id="Ellipse_1"
        data-name="Ellipse 1"
        cx="355"
        cy="32"
        rx="355"
        ry="32"
        transform="translate(51 51)"
        opacity="0.29"
      />
    </svg>
  );
};

export default BoxShadow;
